import React from "react";
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import {useModal} from "../components/Modal";

const Gallery = () => {

    Fancybox.bind('[data-fancybox="gallery"]', {});

    const { handleShowModal } = useModal();

    return (
        <div id="content" className="gallery-page">
            <div className="container-thin">
                <div className="heading">
                    <h1>Fotogalerie</h1>
                    <h2>vzorového domu</h2>
                </div>
            </div>
            <div className="light-grey-bg">
                <div className="container-thin">
                    <div className="gallery">
                        <div className="gallery-items">
                            <a className="gal-item" href="./images/gallery/01.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/01.jpg" alt="img01" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/02.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/02.jpg" alt="img02" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/03.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/03.jpg" alt="img03" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/04.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/04.jpg" alt="img04" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/05.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/05.jpg" alt="img05" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/06.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/06.jpg" alt="img06" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/07.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/07.jpg" alt="img07" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/08.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/08.jpg" alt="img08" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/09.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/09.jpg" alt="img09" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/10.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/10.jpg" alt="img10" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/11.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/11.jpg" alt="img11" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/12.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/12.jpg" alt="img12" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/13.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/13.jpg" alt="img13" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/14.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/14.jpg" alt="img14" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/15.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/15.jpg" alt="img15" loading="lazy" />
                            </a>
                            <a className="gal-item" href="./images/gallery/16.jpg" data-fancybox="gallery">
                                <img src="./images/gallery/16.jpg" alt="img16" loading="lazy" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="extra-info">
                    <div className="extra-text">
                        <h3>Co vám můžeme také zajistit</h3>
                        <ul>
                            <li>Zajištění financování (až 90% ceny)</li>
                            <li>Finální úpravy pozemku</li>
                            <li>Stavba garáže či přístavby</li>
                            <li>Dodání a instalace kuchyňské linky</li>
                            <li>Zasíťování pozemku</li>
                        </ul>
                    </div>
                    <div className="extra-banner">
                        <h2>
                            Domy stavíme na klíč včetně <a href="/vybaveni-domu">bohatého vybavení</a>
                        </h2>
                        <h4>Vnitřní dispozice domu upravujeme na míru dle požadavků zákazníka.</h4>
                        <button onClick={handleShowModal} className="bttn center">Má zájem o konzultaci</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Gallery;